import { useSelector } from 'react-redux';

import { getUserId } from '~store/auth/authSlice';

export const useUserId = () => useSelector(getUserId);
